import { useCallback, useRef, useState } from 'react';
import { Box, Button, Divider, Grid, List, ListItem, ListItemIcon, ListItemText, Paper, TextField, Typography } from '@mui/material';
import VendorLibraries from 'components/vendorLibraries';
import VendorSelect from 'components/vendorSelect';
import { useSnackbar } from 'notistack';
import { bookingsBulkUpload } from 'services/bookings';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const BookingsBulkUpload = () => {

  const [data, setData] = useState({vendor: null, library: null});
  const { enqueueSnackbar } = useSnackbar();
  const UploadFileInutRef = useRef(null);

  const onVendorSelected = useCallback((vendor) => {
    if(data?.vendor?.userId !== vendor?.userId){
      setData({...data, vendor});
    }
  }, [data]);

  const onLibrarySelected = useCallback((library) => {
    if(data?.library?.id !== library?.id){
      setData({...data, library});
    }
  }, [data]);

  function UploadFile() {
    const postData = {
      bookings: UploadFileInutRef.current.files[0],
      propertyId: data.library.id,
      userId: data.vendor.userId,
    };


    bookingsBulkUpload(postData, {}, {}).then(({response, error}) => {
      if(error){
        enqueueSnackbar((error || response?.message || 'Failed to upload data'), {variant: 'error'});
        UploadFileInutRef.current.value='';
      }else{
        enqueueSnackbar((response?.message || 'Data upload successful'), {variant: 'success'});
        setData({vendor: null, library: null});
        UploadFileInutRef.current.value='';
      }
    });
  }

  function onGoBtnClick() {
    if(!(data?.vendor)){
      enqueueSnackbar("Select vendor", {variant: 'error'});
      return;
    }
    if(!(data?.library)){
      enqueueSnackbar("Select library", {variant: 'error'});
      return;
    }
    if(!(UploadFileInutRef?.current?.files[0])){
      enqueueSnackbar("Select File", {variant: 'error'});
      return;
    }
    UploadFile();
  }
  

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Bulk Upload
      </Typography>
      <Divider />
      <Box sx={{ mb: 2, mt:2, px: 4, }} >
        <Grid container columnSpacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} textAlign="right">
            <Button href="/rest/bookings/downloadTemplate" variant="contained" target="_blank">Download Template</Button>
          </Grid>
          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12}  mt={2} spacing={2}>
            <Grid item sx={{pt: 2, }} xs={12} sm={6} md={3} xl={3} lg={3}>
                <VendorSelect onVendorSelected={onVendorSelected}/>
            </Grid>
            <Grid item sx={{pt: 2, }} xs={12} sm={6} md={3} xl={3} lg={3}>
              <VendorLibraries onLibrarySelected={onLibrarySelected} variant="outlined" vendorId={data?.vendor?.userId || null} />
            </Grid>
            <Grid item sx={{pt: 2, }} xs={12} sm={6} md={3} xl={3} lg={3}>
              <TextField type="file"  size="small" inputRef={UploadFileInutRef}
              sx={{width: '100%'}}
                inputProps={{
                  accept: ".csv"
                }}
              />
            </Grid>
            <Grid item sx={{pt: 2, }} xs={12} sm={6} md={3} xl={3} lg={3}>
              <Button variant="contained" onClick={onGoBtnClick} sx={{textTransform:'none', fontSize: 14, py: '7px'}}>Upload</Button>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  mt={4} >
            <Typography variant="subtitle2" component="p" display="block">Notes:</Typography>
            <List
              sx={{ width: '100%', bgcolor: 'background.paper' }}
              component="nav"
            >
              <ListItem>
                <ListItemIcon>
                  <ArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary="Please enter the data in the downloaded template." />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <ArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary="Please enter all dates in dd-MM-yyyy format. For example: 23-01-2022." />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <ArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary="A dummy email id can be entered if not provided." />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <ArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary="Multiple seat numbers to be entered separated by “-”. For example: 1-2-3." />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <ArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary="All amounts to be entered in numeric format. For example: 450, 390.50 etc." />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <ArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary="Allowed payment types: Cash, Cheque, NEFT/IMPS, UPI." />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <ArrowRightIcon />
                </ListItemIcon>
                <ListItemText primary="If amount due is provided, then due date is mandatory for the respective booking." />
              </ListItem>

            </List>
          </Grid>
        </Grid>
      </Box>  
    </Paper>  
  );
}
 
export default BookingsBulkUpload;
